// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1WRiH","dragIcon":"Choice_dragIcon__3k9SI","left":"Choice_left__3HqF3","input":"Choice_input__EbPQR"};